import { render, staticRenderFns } from "./changeCompany.vue?vue&type=template&id=76a79dfc&scoped=true"
import script from "./changeCompany.vue?vue&type=script&lang=js"
export * from "./changeCompany.vue?vue&type=script&lang=js"
import style0 from "./changeCompany.vue?vue&type=style&index=0&id=76a79dfc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a79dfc",
  null
  
)

export default component.exports